import PropTypes from 'prop-types';
import { SelectSearch } from 'mol-ui';
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import { optionActions } from 'core/Option';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'hooks';

const DoctorPicker = ({
    allowNone = true,
    callType,
    disabled,
    filter = () => true,
    fontSize = '12px',
    hasError,
    height = '40px',
    margin = '0px 0px 10px 0px',
    nullPlaceholder,
    objectChange,
    onChange,
    specialty,
    value,
    width = '100%'
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        professionals,
        professionalsLoading: loading
    } = useSelector('option');

    const fetchDoctors = useCallback(() => {
        const params = {
            ...(callType && { callType }),
            ...(specialty && { specialtyId: specialty })
        };
        dispatch(optionActions.getProfessionals(params));
    }, [specialty]);

    useEffect(() => {
        fetchDoctors();
    }, [fetchDoctors]);

    const handleChange = id => {
        if (!objectChange) {
            onChange(id);
        } else {
            const { label: name } = professionals.find(({ value }) => value === id);
            onChange({
                id,
                name
            });
        }
    };

    const parsedProfessionals = clone(professionals).filter(filter);

    if (!isEmpty(parsedProfessionals)) {
        if (!!nullPlaceholder) {
            parsedProfessionals[0] = { ...parsedProfessionals[0], label: nullPlaceholder };
        } else if (!allowNone) {
            parsedProfessionals.splice(0, 1);
        }
    }

    return (
        <SelectSearch
            disabled={ disabled }
            fontSize={ fontSize }
            hasError={ hasError }
            height={ height }
            loading={ loading }
            margin={ margin }
            options={ parsedProfessionals }
            placeholder={ nullPlaceholder ?? t('Seleccione un profesional') }
            value={ value }
            width={ width }
            onChange={ handleChange }
        />
    );
};

DoctorPicker.propTypes = {
    allowNone: PropTypes.bool,
    callType: PropTypes.string,
    disabled: PropTypes.bool,
    filter: PropTypes.func,
    fontSize: PropTypes.string,
    hasError: PropTypes.bool,
    height: PropTypes.string,
    margin: PropTypes.string,
    nullPlaceholder: PropTypes.string,
    objectChange: PropTypes.bool,
    onChange: PropTypes.func,
    specialty: PropTypes.number,
    value: PropTypes.number,
    width: PropTypes.string
};

export default DoctorPicker;
